import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportFehler extends GuiListGeneric {
    constructor() {
        super("Fehler");
    }
}
